export default __webpack_public_path__ + "static/media/addButtonBlack.da63392c.svg";